// extracted by mini-css-extract-plugin
export default {"wrapper":"Description_wrapper__jHZn4","block":"Description_block__OTjiw","value":"Description_value__SIzXq","item":"Description_item__LfR5+","title":"Description_title__Jhje4"};